import {
	MouseEvent,
	ReactNode,
} from 'react';
import {
	useNavigate,
} from 'react-router-dom';
// ENUMS
import {
	EnumFontStyle,
} from '@enums/font.enum';
import {
	EnumTargetLink,
	EnumThemeLink,
} from '@enums/link.enum';
// STYLES
import styles from './link.module.scss';

export interface LinkProps {
	'children'?: ReactNode;
	'className'?: string;
	'data-testid'?: string;
	'disabled'?: boolean;
	'fontWeight'?: EnumFontStyle;
	'href'?: string;
	'onClick'?: (event: MouseEvent<HTMLElement>) => void;
	'target'?: EnumTargetLink;
	'theme'?: EnumThemeLink;
}

export const Link = ({
	children,
	className,
	'data-testid': dataTestid,
	disabled = false,
	fontWeight = EnumFontStyle.SEMIBOLD,
	href,
	onClick,
	target = EnumTargetLink.SELF,
	theme = EnumThemeLink.PRIMARY,
}: LinkProps) => {
	const navigate = useNavigate();

	const classes = [
		styles.link,
	];

	if (className) classes.push(className);
	if (disabled) classes.push(styles[`link__${'disabled'}`]);
	classes.push(styles[`link__${fontWeight}`]);
	classes.push(styles[`link__${theme}`]);

	const handleOnClick = (event: MouseEvent<HTMLElement>) => {
		event.stopPropagation();
		if (disabled) {
			event.preventDefault();
			return;
		}
		// Check if href is an external URL (starts with http://, https://, or //)
		const isExternalUrl = href && (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//'));

		if (target === EnumTargetLink.SELF && !isExternalUrl && href) {
			event.preventDefault();
			navigate(href);
		}
		onClick ? onClick(event) : null;
	};

	return (
		<a
			aria-disabled={disabled}
			className={classes.join(' ')}
			data-testid={dataTestid}
			href={disabled ? undefined : href}
			onClick={handleOnClick}
			target={disabled ? undefined : target}
		>
			{children}
		</a>
	);
};

Link.displayName = 'Link';
